export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-historico-atendimento' */ '@/views/ambulatorio/historico-atendimento/Index'),
        path: 'historico-atendimento',
        redirect: 'historico-atendimento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-historico-atendimento' */'@/views/ambulatorio/historico-atendimento/List.vue'),
                name: 'ambulatorio-historico-atendimento-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-historico-atendimento' */ '@/views/ambulatorio/historico-atendimento/Form.vue'),
                name: 'ambulatorio-historico-atendimento-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]